import React, { useState } from 'react';
import PageBreadcrumb from '@/features/shared/components/PageBreadcrumb';
import { post } from '@/features/shared/lib/api';

/**
 * 마이페이지 프로필 조회 실패 시 전용 화면 (error_code not_found 등)
 * - not_found: 가이드 문구 + 회원 탈퇴
 * - 그 외: 에러 메시지 표시
 */
export default function MypageProfileError({ errorCode, error }) {
  const [withdrawalConfirmText, setWithdrawalConfirmText] = useState('');
  const [withdrawalLoading, setWithdrawalLoading] = useState(false);

  const handleWithdrawal = async () => {
    if (withdrawalConfirmText !== '탈퇴') {
      alert('탈퇴를 원하시면 "탈퇴"를 정확히 입력해 주세요.');
      return;
    }
    if (!window.confirm('정말로 회원 탈퇴를 진행하시겠습니까? 이 작업은 되돌릴 수 없습니다.')) {
      return;
    }
    try {
      setWithdrawalLoading(true);
      const data = await post('/rm/v1/withdrawal', {});
      if (data?.success) {
        const homeUrl = (typeof rmVars !== 'undefined' && rmVars.homeUrl) ? rmVars.homeUrl.replace(/\/+$/, '') : '/';
        alert('개인정보가 삭제되었습니다.');
        window.location.href = homeUrl;
      } else {
        throw new Error(data?.message || '탈퇴 처리에 실패했습니다.');
      }
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || '탈퇴 처리에 실패했습니다. 다시 시도해 주세요.';
      alert(msg);
    } finally {
      setWithdrawalLoading(false);
    }
  };

  const isNotFound = errorCode === 'not_found';

  return (
    <div className="flexPage mt-[127px] lg:mt-[120px] lg:px-6 xl:px-[100px]">
      <div className="w-full px-6 lg:px-0 mt-[30px] lg:mt-[68px]">
        <PageBreadcrumb current="My page" />
        <div className="tit-area w-full flex justify-between gap-3">
          <h2 className="text-[26px] leading-[130%] font-black lg:text-[32px]">My page</h2>
        </div>
        <div className="mt-[30px] lg:mt-8 lg:p-[60px] bg-white rounded-[12px] text-center">
          {isNotFound ? (
              <>
                <h3 className="text-[18px] lg:text-[20px] font-bold text-[#333] mb-3">
                  연구자의 프로파일이 존재하지 않습니다.
                </h3>
                <p className="text-[14px] lg:text-[15px] text-[#6C7687] leading-[160%] mb-2">
                  연구자의 논문이 아직 구축되지 않았거나 프로파일이 생성되지 않았습니다.
                </p>
                <p className="text-[14px] lg:text-[15px] text-[#6C7687] leading-[160%] mb-10">
                  관련 문의는{' '}
                  <a
                      href="/qna/"
                      className="inline-block px-2 py-[4px] border border-[#2F6BFF] text-[#2F6BFF] text-[13px] font-medium rounded-[6px] hover:bg-[#2F6BFF] hover:text-white transition"
                  >
                    Q&A 문의 게시판
                  </a>
                  을 이용하시거나 사이트 하단의 연락처로 문의하여 주시기 바랍니다.
                </p>
                <hr className="border-0 border-t border-[#E4E8F1] my-8"/>
                <div className="text-center max-w-[560px] mx-auto">
                  <p className="mb-4 text-[18px] font-bold text-[#333]">회원 탈퇴</p>
                  <p className="mb-4 text-[14px] text-[#6C7687] leading-[160%]">
                    탈퇴를 진행하시려면 아래 입력란에 <strong>탈퇴</strong>를 입력한 뒤 버튼을 눌러 주세요.
                  </p>
                  <input
                      type="text"
                      value={withdrawalConfirmText}
                      onChange={(e) => setWithdrawalConfirmText(e.target.value)}
                      placeholder="탈퇴"
                      className="w-full max-w-[300px] h-[44px] px-4 border border-[#E4E8F1] rounded-[8px] text-[14px] placeholder-[#B4BCCC] outline-none mb-4 mx-auto block"
                      disabled={withdrawalLoading}
                  />
                  <button
                      type="button"
                      onClick={handleWithdrawal}
                      disabled={withdrawalLoading || withdrawalConfirmText !== '탈퇴'}
                      className={`h-[48px] px-8 text-[15px] font-semibold rounded-[12px] mx-auto block ${
                          withdrawalLoading || withdrawalConfirmText !== '탈퇴'
                              ? 'bg-[#B4BCCC] text-white cursor-not-allowed'
                              : 'bg-[#D90000] text-white hover:bg-[#B30000] cursor-pointer'
                      }`}
                  >
                    {withdrawalLoading ? '처리 중...' : '회원 탈퇴하기'}
                  </button>
                </div>
              </>
          ) : (
              <p className="text-[15px] text-[#6C7687] leading-[160%]">
                {error || '오류가 발생했습니다.'}
              </p>
          )}
        </div>
      </div>
    </div>
  );
}
